var map = {
	"./common/en.ts": 610,
	"./common/zh.ts": 611,
	"./data-online/en.ts": 612,
	"./data-online/zh.ts": 613,
	"./error-code/en.ts": 614,
	"./error-code/zh.ts": 615,
	"./home/en.ts": 616,
	"./home/zh.ts": 617,
	"./msg-history/en.ts": 618,
	"./msg-history/zh.ts": 619,
	"./personnel/en.ts": 620,
	"./personnel/zh.ts": 621,
	"./printer/en.ts": 622,
	"./printer/zh.ts": 623,
	"./project/en.ts": 624,
	"./project/zh.ts": 625,
	"./setting/en.ts": 626,
	"./setting/zh.ts": 627,
	"./staff/en.ts": 628,
	"./staff/zh.ts": 629,
	"./standard/en.ts": 630,
	"./standard/zh.ts": 631,
	"./system/en.ts": 632,
	"./system/zh.ts": 633,
	"./tag/en.ts": 634,
	"./tag/zh.ts": 635,
	"./tips/en.ts": 636,
	"./tips/zh.ts": 637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 609;